<template>
  <div style="height: 100%">
    <div class="booking-content" v-if="isOK">
      <div class="logo-box">
        <img :src="companyInfo?.logo" alt="" ref="logo" />
      </div>
      <div class="visit-name">{{ invitationInfo?.visitorName }}</div>
      <div class="visit-purpose">
        {{ invitationInfo?.visitorNumber }}{{ $t('人通行') }}
      </div>
      <div>
        <img src="@/assets/images/douDown.png" alt="" class="booking-img" />
      </div>
      <div class="code-box" v-show="!isCancel">
        <div class="code-bg">
          <img src="@/assets/images/codeBG.png" alt="" />
        </div>
        <div class="code-warp">
          <vue-qr
            :text="invitationInfo?.invitationCode"
            :size="136"
            :margin="0"
            ref="qrCode"
            class="code"
          ></vue-qr>
          <div class="verification">
            {{ $t('预约码：') }}{{ invitationInfo?.invitationCode }}
          </div>
        </div>
      </div>
      <div v-show="isCancel" class="cancel-invitation">
        <img src="@/assets/images/canInvitation.png" alt="" />
        <p class="cancel-font">{{ status }}</p>
      </div>
      <div class="booking-type1">
        <img src="@/assets/images/visitTime.png" alt="" class="booking-img" />
        <div class="booking-child">
          <div>
            {{ $t('来访时间：')
            }}{{ dayjs(invitationInfo?.visitTime).format('YYYY-MM-DD') }}
          </div>
          <div>
            {{ dayjs(invitationInfo?.visitTime).format('HH:mm')
            }}{{
              invitationInfo?.visitEndTime &&
              `-${dayjs(invitationInfo?.visitEndTime).format('HH:mm')}`
            }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="booking-font">
        {{ $t('详细地址：') }}{{ invitationInfo?.address || $t('暂无') }}
      </div>
      <div class="booking-font" v-show="!isCancel">
        {{ $t('温馨提示：验证信息仅限来访当日进行登记有效！') }}
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfo, getVisitFree } from './service'
import vueQr from 'vue-qr'

export default {
  name: 'visitorPass',
  components: {
    vueQr,
  },
  data() {
    return {
      invitationInfo: null,
      companyInfo: null,
    }
  },
  methods: {
    async getLogo(companyCode) {
      this.companyInfo = await getCompanyInfo(companyCode)
    },
    async getInfo(id) {
      this.invitationInfo = await getVisitFree({ id })
    },
  },
  computed: {
    status() {
      switch (this.invitationInfo?.status) {
        case 'cancel':
          return this.$t('已取消')
        case 'completed':
          return this.$t('已失效')
        default:
          return
      }
    },
    isCancel() {
      return ['cancel', 'completed'].includes(this.invitationInfo?.status)
    },
    isOK() {
      return !!this.invitationInfo
    },
  },
  created() {
    this.getInfo(this.$route.query.id)
    this.getLogo(this.$route.query.companyCode)
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
/deep/.date-border {
  color: #009bff;
}

/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.booking-content {
  min-height: 100%;
  padding-bottom: 110px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;
  font-size: 14px;
  color: #666666;
  background: url('../../assets/images/shareBG.png') center / 100% 100%
    no-repeat;

  .logo-box {
    width: 110px;
    height: 85px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 26px;

    img {
      max-width: 94px;
      max-height: 78px;
    }
  }

  .visit-name {
    font-size: 17px;
    font-weight: 600;
    color: #373737;
    margin: 20px 0 4px;
  }

  .visit-purpose {
    color: #373737;
    margin-bottom: 12px;
  }

  .line {
    width: 263px;
    height: 1px;
    opacity: 0.19;
    border: 1px solid #a2a2a2;
    margin: 9px 0 15px;
  }

  .booking-type1 {
    display: flex;
    align-items: center;
    width: 250px;
    margin-bottom: 12px;

    .booking-child {
      padding-left: 12px;
    }
  }

  .cancel-invitation {
    margin-top: 10px;
    margin-bottom: 18px;
    height: 161px;
    width: 100px;
    text-align: center;

    img {
      height: 100px;
      width: 100px;
    }

    .cancel-font {
      margin-top: 4px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }

  .code-box {
    width: 180px;
    min-height: 211px;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    position: relative;

    .code-bg {
      position: absolute;

      img {
        width: 180px;
        height: 211px;
      }
    }

    .code-warp {
      position: absolute;
      z-index: 99;
    }

    .code {
      width: 136px;
      height: 136px;
      margin: 23px auto 16px;
    }

    .verification {
      font-size: 18px;
      font-weight: 600;
      color: #30adff;
      line-height: 24px;
    }
  }
}

.booking-img {
  width: 25px;
  height: 25px;
}

.booking-font {
  width: 264px;
  font-size: 12px;
  color: #a2a2a2;
  line-height: 24px;
}
</style>
